var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-row',[_c('v-col',{attrs:{"md":"11"}},[_vm._v(" "+_vm._s(_vm.titulo)+" ")]),_c('v-col',{attrs:{"md":"1"}},[_c('hmi-editable-number-input',{attrs:{"valor":_vm.getValue(_vm.topic),"topic":_vm.topic,"unidades":"%"},on:{"cambio":_vm.escribir}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }